import { render, staticRenderFns } from "./PageSubTitle.vue?vue&type=template&id=354fddc4&scoped=true&"
var script = {}
import style0 from "./PageSubTitle.vue?vue&type=style&index=0&id=354fddc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354fddc4",
  null
  
)

export default component.exports